import script from "./IconFont.vue?vue&type=script&lang=js"
export * from "./IconFont.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__